"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAttributesValid = isAttributesValid;
exports.isMetricsValid = isMetricsValid;
exports.filterAttributes = filterAttributes;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es7.object.values");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _constants = require("../constants");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isAttributesValid(attributes) {
  var valid = true;

  if (_typeof(attributes) === 'object') {
    var keys = Object.keys(attributes);

    if (keys.length > 5) {
      return false;
    }

    keys.forEach(function (key) {
      if (!key || key[0] === ' ' || key[key.length - 1] === ' ' || key[0] === '_' || key.length > 32) {
        valid = false;
      }
    });
    Object.values(attributes).forEach(function (value) {
      if (typeof value !== 'string') {
        valid = false;
      }
    });
  }

  return valid;
}

function isMetricsValid(metrics, predicate) {
  var valid = true;

  if (_typeof(metrics) === 'object') {
    var keys = Object.keys(metrics);

    for (var i = 0; i < keys.length; i++) {
      var value = metrics[keys[i]];
      var predicateResult = true;

      if (predicate && typeof predicate === 'function') {
        predicateResult = predicate(value);
      }

      if (typeof value === 'undefined' || typeof value !== 'number' || !predicateResult) {
        valid = false;
        break;
      }
    }
  }

  return valid;
}

function filterAttributes(endpoint, type, attributes) {
  var config = _constants.ATTRIBUTES_KEYS_BY_TYPE[endpoint] || {};
  var keys = config[type] || [];
  var result = {};
  Object.keys(attributes).forEach(function (key) {
    if (keys.indexOf(key) > -1) {
      result[key] = attributes[key];
    }
  });
  return result;
}